import type { Menu } from '@/menus/types.ts';

export default [
  {
    code: 'WORKFLOW',
    icon: 'menu-workflow',
    label: '流程管理',
    remark: '工作流相关企业级别管理、查询、操作等',
    children: [
      {
        code: 'WORKFLOW_DEFINITION',
        icon: 'menu-workflow-definition',
        label: '流程定义',
        path: '/workflow/definition',
      },
      {
        code: 'WORKFLOW_INSTANCE',
        icon: 'menu-workflow-instance',
        label: '实例管理',
        path: '/workflow/instance',
      },
      {
        code: 'WORKFLOW_MONITOR',
        icon: 'menu-workflow-monitor',
        label: '流程监控',
        path: '/workflow/monitor',
      },
      {
        code: 'WORKFLOW_DELEGATE',
        icon: 'menu-workflow-delegate',
        label: '委托代理',
        path: '/workflow/delegate',
      },
    ],
  },
] satisfies Menu[];
